import { useCallback } from 'react';
import { useRequiredCurrentUser } from 'FrontRoyalAngular';
import { navigationHelper } from 'NavigationHelpers';
import { getAoiRecord } from 'Users';

// Opens the cohort's program guide. Mirrors `scope.launchProgramGuide` in settings_dir.js, which
// opens the system browser on Cordova and a new tab elsewhere.
export function useLaunchProgramGuide(): () => void {
    const currentUser = useRequiredCurrentUser();
    const { loadUrl } = navigationHelper();

    return useCallback(() => {
        const url = getAoiRecord(currentUser)?.cohortProgramGuideUrl;
        if (!url) return;
        loadUrl(url, window.CORDOVA ? '_system' : '_blank');
    }, [currentUser, loadUrl]);
}
